export default __webpack_public_path__ + "static/media/Sapthagiri.a2423517.png";